import { Table, TableColumns } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

type SelectPlanungPersonTableProps = {
  selectedPlanungPerson: SelectPlanungPersonTableDataType | null;
  onRowSelectionChange: (planungPerson: SelectPlanungPersonTableDataType | null) => void;
  data: SelectPlanungPersonTableDataType[];
};

export type SelectPlanungPersonTableDataType = {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
};

export const SelectPlanungPersonTable = ({
  selectedPlanungPerson,
  onRowSelectionChange,
  data,
}: SelectPlanungPersonTableProps) => {
  const { t } = useTranslation();

  const columns: TableColumns<SelectPlanungPersonTableDataType>[] = [
    {
      header: t('common.firstName'),
      id: 'firstName',
      accessorKey: 'firstName',
    },
    {
      header: t('common.lastName'),
      id: 'lastName',
      accessorKey: 'lastName',
    },
    {
      header: t('common.email'),
      id: 'email',
      accessorKey: 'email',
    },
    {
      header: t('role.title', { count: 1 }),
      id: 'role',
      accessorKey: 'role',
    },
  ];

  const currentIndex = data.findIndex((p) => p.uuid === selectedPlanungPerson?.uuid);
  const currentIndexObject = currentIndex >= 0 ? { [currentIndex]: true } : {};

  return (
    <Table<SelectPlanungPersonTableDataType>
      showActionBar={true}
      actionBarSettings={{
        showGlobalFilter: true,
      }}
      data={data}
      columns={columns}
      canScroll={false}
      isOnWhite={true}
      selectOnClick={true}
      showSelect={true}
      showSelected
      rowSelection={currentIndexObject}
      onRowSelectionChange={(updaterOrValue) => {
        const selection = typeof updaterOrValue === 'function' ? updaterOrValue({}) : updaterOrValue;
        const selectedIndex = parseInt(Object.keys(selection)[0]);
        const selectedPlanungPerson = data.find((item, key) => key === selectedIndex);
        if (selectedPlanungPerson) {
          onRowSelectionChange(selectedPlanungPerson);
        } else {
          onRowSelectionChange(null);
        }
      }}
    ></Table>
  );
};
